module.exports = __webpack_public_path__ + "img/intrbak.161adcae.png";